import React from 'react';
import { useHistory } from 'react-router-dom';

import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';

import {
  Container,
  BookingInfoHeader,
  BookingInfoDates,
  BookingInfoRooms,
  RoomLabel,
  RoomGuest,
  EditIcon,
  EditContainer,
  DateContainer,
  Date,
  RoomContainer,
} from './styles';

export interface Props {
  checkIn: Date;
  checkOut: Date;
  isEdit?: boolean;
}

const BookingInfo = ({ checkIn, checkOut, isEdit }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  return (
    <Container>
      <BookingInfoHeader>
        <BookingInfoDates>
          <DateContainer>
            {t('hotelBookingInfo.checkIn')}
            <Date>{moment(checkIn).utc().format('DD MMM')}</Date>
          </DateContainer>
          <DateContainer>
            {t('hotelBookingInfo.checkOut')}
            <Date>{moment(checkOut).utc().format('DD MMM')}</Date>
          </DateContainer>
        </BookingInfoDates>
        <BookingInfoRooms>
          <RoomContainer>
            <RoomLabel>{t('hotelBookingInfo.roomQuantity', { count: 1 })}</RoomLabel>
            <RoomGuest>{t('hotelBookingInfo.guestQuantity', { count: 1 })}</RoomGuest>
          </RoomContainer>
        </BookingInfoRooms>
      </BookingInfoHeader>
      {isEdit && (
        <EditContainer>
          <EditIcon src="/images/edit-booking.svg" onClick={() => history.push('/booking/hotels')} />
        </EditContainer>
      )}
    </Container>
  );
};

export default BookingInfo;
